import { default as PrivateRoute } from './PrivateRoute';

export default PrivateRoute;
